module.exports = __webpack_public_path__ + "static/media/nago.133dfcf9.mp4";